import gallery1 from "../assets/images/gallery/gallery-01.jpg";
import gallery2 from "../assets/images/gallery/gallery-02.jpg";
import gallery3 from "../assets/images/gallery/gallery-03.jpg";
import gallery4 from "../assets/images/gallery/gallery-04.jpg";
import gallery5 from "../assets/images/gallery/gallery-05.jpg";

export const fetchGallery = async () => {
    return [
      {
        id: 1,
        title: 'Image 1',
        image: gallery1,
        data_aos_delay: '100ms',
      },
      {
        id: 2,
        title: 'Image 2',
        image: gallery2,
        data_aos_delay: '200ms',
      },
      {
        id: 3,
        title: 'Image 3',
        image: gallery3,
        data_aos_delay: '300ms',
      },
      {
        id: 4,
        title: 'Image 4',
        image: gallery4,
        data_aos_delay: '400ms',
      },
      {
        id: 5,
        title: 'Image 5',
        image: gallery5,
        data_aos_delay: '500ms',
      },
    ];
}